import React from 'react'
import './shop.css'

export default function Shop() {
  return (
    <>
      <img src="images/page404.gif" alt="" style={{"width":"100%", "height":"90vh"}}/>
    </>
  )
}
